


export class MainCharityLotsView {

    constructor() {

        this.widget = document.querySelector('.charity_lots');

        this.container = this.widget.querySelector('.charity_lots .sc_body .item_slider .frame .stage .ul');
        if (!this.container) { return;}

        const firstItem = this.container.querySelector('.item');
        if (firstItem) {
            this.templateWrapper = firstItem.closest('.li') || firstItem;
        }
    }

    render(state) { 

        if (!state || !state.data || !Array.isArray(state.data.items) || state.data.items.length === 0) { return;}

        this.widget.querySelector('.sc_title em').innerHTML = state.data.totalCount;
        
        const items = [...state.data.items].sort(() => Math.random() - 0.5);

        const moreBtnWrapper = this.container.querySelector('.li.li_more');
        
        if (moreBtnWrapper && state.data.totalCount > 20) {
            const countBlock = moreBtnWrapper.querySelector('.count');
            if (countBlock) { countBlock.textContent = state.data.totalCount;}
            
            moreBtnWrapper.style.display = ''; 
            moreBtnWrapper.querySelector('a.stub_more').href = state.data.url;
        }

        items.forEach((itemData) => {

            const currentDummy = this.container.querySelector('.item.dummy');

            if (currentDummy) {

                this.renderPartial(currentDummy, itemData);

            } else if (this.templateWrapper) {

                const newWrapper = this.templateWrapper.cloneNode(true);
                
                const newItem = newWrapper.querySelector('.item');
                
                if (newItem) {

                    newItem.classList.add('dummy'); 
                    
                    this.renderPartial(newItem, itemData);
                }
                
                this.container.insertBefore(newWrapper, moreBtnWrapper);
            }
        });

        this.widget.querySelector('.sc_header').href = state.data.url;

    }

    renderPartial(element, itemData) {

        if (!element || !itemData) return;

        const previewLink = element.querySelector('.preview');
        const img = element.querySelector('.preview img');
        if (previewLink) previewLink.href = itemData.url || '#';
        if (img) {
            img.src = itemData.firstImageUrl || '/i/null.gif';
            img.alt = itemData.title || '';
        }

        const titleLink = element.querySelector('.content .title');
        if (titleLink) {
            titleLink.href = itemData.url || '#';
            titleLink.textContent = itemData.title || '';
        }

        const priceParagraph = element.querySelector('.price .p_box .current p');
        const priceCurrency = element.querySelector('.price .p_box .current span');
        
        if (priceParagraph && itemData.price) {
            priceParagraph.textContent = itemData.price.value || '';
        }
        if (priceCurrency && itemData.price) {
            priceCurrency.textContent = itemData.price.currency || '';
        }

        element.classList.remove('dummy');
    }
}